import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_RegistryFilterCard = _resolveComponent("RegistryFilterCard")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.filters.length > 0)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-m-2"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.registry.filters')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("div", {
            class: "filter-container",
            style: _ctx.registryDescriptor.styles.filterContainer
          }, [
            _createVNode("div", {
              class: "fields-container",
              style: _ctx.registryDescriptor.styles.fieldsContainer
            }, [
              _createVNode("form", _hoisted_1, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
                  return (_openBlock(), _createBlock(_component_RegistryFilterCard, {
                    key: index,
                    class: "kn-flex p-mx-2",
                    id: _ctx.id,
                    propFilter: filter,
                    entity: _ctx.entity,
                    clearTrigger: _ctx.clearFiltersTrigger,
                    onChanged: ($event: any) => (_ctx.setFilterValue($event, index)),
                    onValid: _ctx.setFilterButtonDisabled
                  }, null, 8, ["id", "propFilter", "entity", "clearTrigger", "onChanged", "onValid"]))
                }), 128))
              ])
            ], 4),
            _createVNode("div", {
              class: "button-container p-ml-2",
              style: _ctx.registryDescriptor.styles.buttonsContainer
            }, [
              _createVNode(_component_Button, {
                class: "p-button kn-button--primary p-mx-1",
                style: _ctx.registryDescriptor.styles.filtersButton,
                onClick: _ctx.clearAllFilters
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.registry.clearFilters')), 1)
                ]),
                _: 1
              }, 8, ["style", "onClick"]),
              _createVNode(_component_Button, {
                class: "p-button kn-button--primary p-mx-1",
                style: _ctx.registryDescriptor.styles.filtersButton,
                onClick: _ctx.filterRegistry,
                "data-test": "filter-button",
                disabled: _ctx.filterButtonDisabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.registry.filter')), 1)
                ]),
                _: 1
              }, 8, ["style", "onClick", "disabled"])
            ], 4)
          ], 4)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}